import React from "react";
import styled from "styled-components";

import ModalBasic from "./ModalBasic.jsx";

const ModalChatSession = ({
  isOpen,
  isLoading,
  errorMessage,
  onContinue,
  onStartNew,
  title = "진행 중인 대화가 있습니다.",
  description = "현재 대화를 계속하거나 종료한 뒤 새로운 상황을 시작할 수 있습니다.",
  continueLabel = "대화 계속",
  startNewLabel = "새로운 상황",
}) => (
  <ModalBasic
    isOpen={isOpen}
    onClose={() => {}}
    width={window.innerWidth > 430 ? "400px" : "312px"}
    height="fit-content"
    shouldCloseOnOverlayClick={false}
    shouldCloseOnEsc={false}
  >
    <ContentWrapper>
      <Header>{title}</Header>
      <Content>{description}</Content>
      {errorMessage && <ErrorMessage role="alert">{errorMessage}</ErrorMessage>}
      <ButtonWrapper>
        <Button type="button" onClick={onContinue} disabled={isLoading}>
          {continueLabel}
        </Button>
        <Button
          type="button"
          $primary
          onClick={onStartNew}
          disabled={isLoading}
        >
          {isLoading ? "전환 중" : startNewLabel}
        </Button>
      </ButtonWrapper>
    </ContentWrapper>
  </ModalBasic>
);

const ContentWrapper = styled.div`
  padding: 32px;

  @media (max-width: 430px) {
    padding: 24px;
  }
`;

const Header = styled.div`
  color: #000;
  font-size: 18px;
  font-weight: 700;

  @media (max-width: 430px) {
    font-size: 16px;
  }
`;

const Content = styled.div`
  margin: 16px 0;
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;

  @media (max-width: 430px) {
    font-size: 14px;
    line-height: 24px;
  }
`;

const ErrorMessage = styled.div`
  margin: -4px 0 16px;
  color: #d32f2f;
  font-size: 14px;
  line-height: 22px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;

  @media (max-width: 430px) {
    flex-direction: column;
  }
`;

const Button = styled.button`
  min-width: 88px;
  height: 40px;
  padding: 0 14px;
  border: 0;
  border-radius: 6px;
  background: ${({ $primary }) => ($primary ? "#000" : "#f2f2f2")};
  color: ${({ $primary }) => ($primary ? "#fff" : "#000")};
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;

  &:disabled {
    background: rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.3);
    cursor: not-allowed;
  }

  @media (max-width: 430px) {
    width: 100%;
    min-width: 0;
    font-size: 14px;
    white-space: nowrap;
  }
`;

export default ModalChatSession;
